// imports section Start
import React from "react";
import {
  Box,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  DialogTitle,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../../../assets/styles/Theme";
// imports section End

export default function CashierCategoryMobile({
  categories,
  onSelectCategory,
  onClose,
  existingCategories,
}) {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  // Hooks end

  // Handlers start
  // Key Point: Remove duplicate categories based on MENUCATCODE
  const uniqueCategories = Array.from(
    new Set(categories.map((category) => category.MENUCATCODE))
  ).map((uniqueCatCode) =>
    categories.find((category) => category.MENUCATCODE === uniqueCatCode)
  );

  // Key Point: Sort the unique categories by MENUCATNAME in ascending order
  const sortedCategories = uniqueCategories.sort((a, b) =>
    a.MENUCATNAME.localeCompare(b.MENUCATNAME)
  );
  // Handlers end

  return (
    <Box sx={styles.m_category_list} p={2}>
      <Typography sx={styles.m_category_list_title}>
        Select a Category
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={styles.m_category_list_close_icon}
        >
          <CloseIcon />
        </IconButton>
      </Typography>
      <Grid container spacing={2} pt={1}>
        {sortedCategories.map((category) => (
          <Grid item xs={12} sm={12} md={6} key={category.MENUCATCODE}>
            <List sx={{ width: "100%", p: 0 }}>
              <ListItem
                button
                onClick={() => onSelectCategory(category)}
                sx={styles.m_category_list_items}
              >
                <ListItemText primary={category.MENUCATNAME} />
              </ListItem>
            </List>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
